import type { ReactNode } from 'react'

import { useUTMParams } from '@/hooks/useUTMParams'

interface UTMProviderProps {
    children: ReactNode
}

/**
 * Provider component that captures and manages UTM parameters
 * Should be placed high in the component tree to ensure UTM params are captured early
 */
export const UTMProvider = ({ children }: UTMProviderProps) => {
    // This hook will automatically capture and persist UTM params
    useUTMParams()

    return children
}
